export default "__VITE_ASSET__DmRUziPX__"